import styled from 'styled-components';

export const Wrapper = styled.div`
  .navbar {
    flex-grow: 1;
    margin-bottom: 1rem;
  }

  .menu-button {
    margin-right: ${props => `${props.theme.spacing(2)}px`};
  }

  .title {
    flex-grow: 1;
    display: flex;
    align-items: center;

    .logo {
      margin-right: 1rem;
    }
  }

  .login-button {
    color: ${props => props.theme.palette.primary.contrastText};
  }

  .hidden-tab {
    visibility: hidden;
    position: absolute;
    left: -9999px;
  }
`;